"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSListingsWithFilters = void 0;
const mobx_1 = require("mobx");
const vocabularies_1 = require("../vocabularies");
const posListingsWithFiltersHelpers_1 = require("../helpers/posListingsWithFiltersHelpers");
const CategoryFilterOption_1 = require("./filterOptions/CategoryFilterOption");
const PriceFilterOption_1 = require("./filterOptions/PriceFilterOption");
const QueryFilterOption_1 = require("./filterOptions/QueryFilterOption");
const StockFilterOption_1 = require("./filterOptions/StockFilterOption");
const SupplierFilterOption_1 = require("./filterOptions/SupplierFilterOption");
const CannabisWeightFilterOption_1 = require("./filterOptions/CannabisWeightFilterOption");
const UnitFilterOption_1 = require("./filterOptions/CannabinoidsFilterOption/UnitFilterOption");
const SortFilterOption_1 = require("./filterOptions/SortFilterOption");
const ThcFilterOption_1 = require("./filterOptions/CannabinoidsFilterOption/ThcFilterOption");
const CbdFilterOption_1 = require("./filterOptions/CannabinoidsFilterOption/CbdFilterOption");
const OnSaleFilterOption_1 = require("./filterOptions/OnSaleFilterOption");
const products_1 = require("@getgreenline/products");
const BatchCannabinoidHelpers_1 = require("./helpers/BatchCannabinoidHelpers");
const StrainTypeFilterOption_1 = require("./filterOptions/StrainTypeFilterOption");
class POSListingsWithFilters {
    constructor() {
        this.ITEMS_PER_PAGE = 40;
        this.cannabisWeightFilterOption = new CannabisWeightFilterOption_1.CannabisWeightFilterOption();
        this.categoryFilterOption = new CategoryFilterOption_1.CategoryFilterOption();
        this.cbdFilterOption = new CbdFilterOption_1.CbdFilterOption();
        this.onSaleFilterOption = new OnSaleFilterOption_1.OnSaleFilterOption();
        this.priceFilterOption = new PriceFilterOption_1.PriceFilterOption();
        this.queryFilterOption = new QueryFilterOption_1.QueryFilterOption();
        this.sortFilterOption = new SortFilterOption_1.SortFilterOption();
        this.stockFilterOption = new StockFilterOption_1.StockFilterOption();
        this.supplierFilterOption = new SupplierFilterOption_1.SupplierFilterOption();
        this.thcFilterOption = new ThcFilterOption_1.ThcFilterOption();
        this.unitFilterOption = new UnitFilterOption_1.UnitFilterOption();
        this.strainTypeFilterOption = new StrainTypeFilterOption_1.StrainTypeFilterOption();
        this.filteredListings = [];
        this.filteredListingsRangeEnd = this.ITEMS_PER_PAGE;
        this.reset = () => {
            this.cannabisWeightFilterOption.reset();
            this.categoryFilterOption.reset();
            this.cbdFilterOption.reset();
            this.onSaleFilterOption.reset();
            this.priceFilterOption.reset();
            this.queryFilterOption.reset();
            this.sortFilterOption.reset();
            this.stockFilterOption.reset();
            this.supplierFilterOption.reset();
            this.thcFilterOption.reset();
            this.unitFilterOption.reset();
            this.strainTypeFilterOption.reset();
        };
        this.resetOnlyFilters = () => {
            this.cannabisWeightFilterOption.reset();
            this.categoryFilterOption.reset();
            this.cbdFilterOption.reset();
            this.onSaleFilterOption.reset();
            this.priceFilterOption.reset();
            this.queryFilterOption.reset();
            this.sortFilterOption.reset();
            this.supplierFilterOption.reset();
            this.thcFilterOption.reset();
            this.unitFilterOption.reset();
            this.strainTypeFilterOption.reset();
        };
        this.resetPage = () => {
            this.filteredListingsRangeEnd = this.ITEMS_PER_PAGE;
        };
        this.nextPage = () => {
            this.filteredListingsRangeEnd = this.filteredListingsRangeEnd + this.ITEMS_PER_PAGE;
        };
        this.showAmountError = (minimum, maximum) => {
            if (minimum && maximum && minimum > maximum) {
                return `Minimum amount can't be greater than the maximum amount.`;
            }
        };
        /**
         * In UI, we only show standalone and master products upon selecting a category
         * We actually don't need nested products
         */
        this.filterByStockAndInventory = (POSListings) => (listings) => {
            if (!this.stockFilterOption.showOnlyInStock)
                return listings;
            const filtered = listings.filter((listing) => {
                if (listing.trackInventory) {
                    return listing.quantity > 0;
                }
                const childListings = POSListings.getChildren(listing.id);
                // Include standalone listings
                if (childListings.length === 0) {
                    return true;
                }
                return childListings.some(this.stockFilterOption.shouldBeFiltered);
            });
            return filtered;
        };
        // Combine all target fields into a single string
        this.filterBySearchQuery = (POSListings) => (listings) => {
            if (!this.queryFilterOption.isSet)
                return listings;
            return listings.filter((topLevelListing) => {
                if (this.queryFilterOption.queryExists({
                    POSListings,
                    listing: topLevelListing,
                })) {
                    return true;
                }
                const childListings = POSListings.getChildren(topLevelListing.id);
                return childListings.some((childListing) => this.queryFilterOption.queryExists({
                    POSListings,
                    listing: childListing,
                }));
            });
        };
        this.filterByCategories = (listings) => {
            if (!this.categoryFilterOption.isSet)
                return listings;
            const shouldIncludeUncategorized = this.categoryFilterOption.categoryIds.has(vocabularies_1.FilterVocabulary.UNCATEGORIZED_NAME);
            return listings.filter((listing) => {
                if (!listing.categoryId) {
                    return shouldIncludeUncategorized;
                }
                return this.categoryFilterOption.categoryIds.has(listing.categoryId);
            });
        };
        this.filterBySuppliers = (listings) => {
            if (!this.supplierFilterOption.isSet)
                return listings;
            return listings.filter((listing) => this.supplierFilterOption.supplierIdExists(listing.supplierId));
        };
        /**
         * When price filter is set, filter out all listings that don't match the price range
         * And master product with `null` null shouldn't be included but only show its children as standalone products
         */
        this.filterByPrice = (POSListings, discounts) => (listings) => {
            if (!this.priceFilterOption.isSet)
                return listings;
            return listings.filter((listing) => {
                const salePrice = (0, posListingsWithFiltersHelpers_1.getSalePrice)({
                    listing,
                    discounts,
                    categories: POSListings.refData.categories,
                });
                return this.priceFilterOption.isInRange(salePrice);
            });
        };
        this.filterByCannabisWeight = (listings) => {
            if (!this.cannabisWeightFilterOption.isSet)
                return listings;
            return listings.filter((listing) => this.cannabisWeightFilterOption.isInRange(listing.cannabisWeight));
        };
        this.filterByThcAndCbdPerBatch = (POSListings) => (listings) => {
            const filtered = listings.filter((listing) => {
                const batches = POSListings.products.batches.getAllPerProduct(listing.id);
                let shouldBeFiltered = false;
                if (batches.length > 0) {
                    shouldBeFiltered = batches.some((batch) => {
                        return BatchCannabinoidHelpers_1.BatchCannabinoidHelpers.isBatchInRange(batch, listing, this.cbdFilterOption, this.thcFilterOption, this.unitFilterOption);
                    });
                }
                else {
                    shouldBeFiltered = BatchCannabinoidHelpers_1.BatchCannabinoidHelpers.isBatchInRange(undefined, listing, this.cbdFilterOption, this.thcFilterOption, this.unitFilterOption);
                }
                return shouldBeFiltered;
            });
            return filtered;
        };
        this.filterByOnSale = (POSListings, discounts) => (listings) => {
            if (!this.onSaleFilterOption.isSet)
                return listings;
            return listings.filter((listing) => {
                const automaticDiscount = (0, posListingsWithFiltersHelpers_1.getAvailableAutomaticDiscount)({
                    listing,
                    discounts,
                    categories: POSListings.refData.categories,
                });
                return automaticDiscount !== undefined;
            });
        };
        this.filterSystemProducts = (listings) => {
            return listings.filter((listing) => listing.productType !== products_1.ProductModels.ProductType.FEE &&
                listing.productType !== products_1.ProductModels.ProductType.TIP);
        };
        this.filterByStrainType = (listings) => {
            if (!this.strainTypeFilterOption.isSet)
                return listings;
            return listings.filter((listing) => listing.strainType &&
                this.strainTypeFilterOption.selectedStrainTypes.has(listing.strainType));
        };
        this.applyFilters = (POSListings, discounts) => {
            const filterFunctions = [
                this.filterSystemProducts,
                this.filterByCategories,
                this.filterBySuppliers,
                this.filterByPrice(POSListings, discounts),
                this.filterByCannabisWeight,
                this.filterBySearchQuery(POSListings),
                this.filterByThcAndCbdPerBatch(POSListings),
                this.filterByOnSale(POSListings, discounts),
                this.filterByStockAndInventory(POSListings),
                this.filterByStrainType,
            ];
            const filteredListings = (0, posListingsWithFiltersHelpers_1.composeFilters)(...filterFunctions)(POSListings.flattenedListings);
            this.filteredListings = this.sortFilterOption.filter(filteredListings);
        };
    }
    get isFiltered() {
        return (this.categoryFilterOption.isSet ||
            this.queryFilterOption.isSet ||
            this.supplierFilterOption.isSet ||
            this.priceFilterOption.isSet ||
            this.cannabisWeightFilterOption.isSet ||
            this.onSaleFilterOption.isSet ||
            this.thcFilterOption.isSet ||
            this.cbdFilterOption.isSet ||
            this.strainTypeFilterOption.isSet);
    }
    get isFilterChanged() {
        return this.isFiltered || this.sortFilterOption.isSet || !this.stockFilterOption.showOnlyInStock;
    }
    get listingsFromRange() {
        return this.filteredListings.slice(0, this.filteredListingsRangeEnd);
    }
    // Filter all cart discounts that contains only included products (bundle discount)
    filterBundledDiscounts(discounts) {
        const cartDiscounts = discounts.filter((discount) => discount.applyType === 'cart');
        const bundleDiscounts = cartDiscounts.filter((discount) => {
            const products = discount.products;
            const productsWithDiscountTypeInclude = products && products.filter((product) => product.type === 'include');
            return (productsWithDiscountTypeInclude &&
                products.length > 0 &&
                products.length === productsWithDiscountTypeInclude.length);
        });
        return bundleDiscounts;
    }
}
exports.POSListingsWithFilters = POSListingsWithFilters;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Array)
], POSListingsWithFilters.prototype, "filteredListings", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "filteredListingsRangeEnd", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "reset", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "resetOnlyFilters", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "resetPage", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "nextPage", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], POSListingsWithFilters.prototype, "applyFilters", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], POSListingsWithFilters.prototype, "isFiltered", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], POSListingsWithFilters.prototype, "isFilterChanged", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], POSListingsWithFilters.prototype, "listingsFromRange", null);
//# sourceMappingURL=POSListingsWithFilters.js.map